import { when } from '@execonline-inc/maybe-adapter';
import { observer } from 'mobx-react';
import { Navigate } from 'react-router';
import LearningCollectionEditStore from '../../Edit/Store';
import Celebration from './Celebration';
import { Visibility } from '../../Edit/Store/Types';
import { equals } from '@execonline-inc/collections';

interface Props {
  celebrate: Visibility;
  store: LearningCollectionEditStore;
}
const Finishing: React.FC<Props> = ({ celebrate, store }) =>
  when(equals(celebrate, 'show'), {})
    .map(() => <Celebration store={store} />)
    .getOrElse(() => <Navigate to="/learning_collections" />);

export default observer(Finishing);
